import {
  isFavouritesClientAddError,
  isFavouritesClientRemoveError,
} from '@johnlewispartnership/wtr-website-favourites-sdk';

import { logger } from 'logger';
import { updateFavouriteNetworkErrorModal, unexpectedErrorModal } from 'constants/modals/modals';
import type { GetErrorModal } from 'types/react-query';

type UpdateFavouritesMutationContext = {
  action: 'add' | 'remove';
};

const isUpdateFavouriteMutationContext = (
  context: unknown,
): context is UpdateFavouritesMutationContext => {
  if (typeof context !== 'object' || context === null) return false;

  const action = (context as Record<string, unknown>).action;

  return action === 'add' || action === 'remove';
};

export const updateFavouriteMutationErrorModal: GetErrorModal = ({ error, variables, context }) => {
  const action = isUpdateFavouriteMutationContext(context) ? context.action : 'update';

  if (isFavouritesClientAddError(error) || isFavouritesClientRemoveError(error)) {
    logger.error({
      payload: {
        message: `Failed to ${action} favourite: ${variables}`,
        service: 'favourites',
        errorDetails: {
          message: error.message,
          name: error.name,
          stack: error.stack,
        },
      },
    });

    return updateFavouriteNetworkErrorModal;
  }

  const errorDetails = error instanceof Error ? error : {};

  logger.error({
    payload: {
      message: `Failed to ${action} favourite: ${variables}`,
      service: 'favourites',
      errorDetails,
    },
  });

  return unexpectedErrorModal;
};
